import HeadingThree from '@/components/ui/headings/HeadingThree';
import { useEffect, useState } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import { useTranslation } from 'react-i18next';
import { getStorageUrl } from '@/utils/utils';

type Character = {
    name: string;
    image: string;
    content: string;
};

type SeriesHeroesProps = {
    characters: Character[] | undefined;
};

const SeriesHeroes: React.FC<SeriesHeroesProps> = ({ characters }) => {
    const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true });
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [activeIndexes, setActiveIndexes] = useState([]);
    const { t } = useTranslation();

    const toggleIndex = (index: any) => {
        if (activeIndexes.includes(index)) {
            setActiveIndexes(activeIndexes.filter((i) => i !== index));
        } else {
            setActiveIndexes([...activeIndexes, index]);
        }
    };

    const onSelect = () => {
        if (!emblaApi) return;
        setSelectedIndex(emblaApi.selectedScrollSnap());
    };

    useEffect(() => {
        if (!emblaApi) return;
        emblaApi.on('select', onSelect);
        onSelect();
    }, [emblaApi]);

    return (
        // lg:mt-[96px] md:mt-[80px] sm:mt-[67px] mt-[56px]
        <div className=" flex flex-col items-center mainContainer-seriesHeroes">
            <HeadingThree headThree={t('project.series')} />

            <div className="w-full lg:mt-36 md:mt-32 mt-28">
                {/* Apply Embla only on screens smaller than md */}
                <div className="">
                    <div className="emblaa" ref={emblaRef}>
                        <div className="embla__container md:gap-6 gap-4 flex items-center justify-center">
                            {characters?.map((data, i) => (
                                <div
                                    key={i}
                                    className={`embla__slide gradientSeriesHeroBox md:max-w-[285px] md:min-h-[490px] h-full max-w-[150px] w-full min-h-[260px] ${i === characters?.length - 1 ? 'md:mr-[24px] mr-[16px]' : ''}`}
                                >
                                    <div
                                        className={`text-center ${
                                            activeIndexes.includes(i) ? 'animate-up' : 'animate-default'
                                        }`}
                                        onClick={() => toggleIndex(i)}
                                    >
                                        <img
                                            src={getStorageUrl(data?.image)}
                                            alt="Hero"
                                            className="max-w-[116px] w-full mx-auto min-h-[188px] md:max-w-[205px] md:min-h-[379px] h-full"
                                        />
                                        <h3 className="lg:text-[40px] md:text-[33px] sm:text-[26px] text-[20px] mx-auto lg:mb-[25px] md:mb-[22px] sm:mb-[19px] mb-[17px] font-bold text-Grey20">
                                            {data.name}
                                        </h3>
                                        {activeIndexes.includes(i) && (
                                            <p className="lg:text-[20px] md:text-[17px] text-[14px] text-center text-Grey20 mt-2">
                                                {data.content}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SeriesHeroes;
